// React imports.
import React from "react";

import { Assessment2bStepsEnum } from "../state";
import { Assessment2bHHDataReceivedStatusEnum } from "../state";
import { Assessment2bHHServedByVendorsDataRequestedStatusEnum } from "../state";
import { Assessment2bHHServedByVendorsDataReceivedStatusEnum } from "../state";
import { Assessment2bHHWithElectricDataStatusEnum } from "../state";
import { Assessment2bHH12MonthBillingDataNumStatusEnum } from "../state";
const Assessment2bQuestions = ({fuelType, state}) => (
    <div>
        {/*OverTargetNoIssues*/}
        {(fuelType.hhDataReceivedStatus2b == Assessment2bHHDataReceivedStatusEnum.OverTargetNoIssues
            &&fuelType.viewAnywayFlag != true)
          &&<p>
              This means that your data is likely representative of all LIHEAP
              households in your state/territory and you likely do not have a data
              reliability issue with regard to data recording and processing
              for   {fuelType.description}   household electric expenditure data.
              <br/><br/>
              No further action is required for   {fuelType.description}   households
              in Assessment #2B. If you want to analyze potential data
              reliability issues for   {fuelType.description}   data anyway,
              click&nbsp;<button className="dataButton"
                        onClick={(changeEvent) => state.assessment2bViewAnyway(changeEvent, fuelType)}>
                        here
                    </button>. Otherwise, click next.
          </p>
        }
        {/*NoHouseholdsServed*/}
        {(fuelType.hhDataReceivedStatus2b == Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed)
          &&<p>
              No further action is required for   {fuelType.description}   households
              in Assessment #2B.  Click next to continue.
          </p>
        }
        {(fuelType.hhDataReceivedStatus2b == Assessment2bHHDataReceivedStatusEnum.NotMeetTarget
            || fuelType.viewAnywayFlag === true)
          &&
          <React.Fragment>
              <p>
                  Let&rsquo;s explore some reasons that electric vendors would not report enough
                  information:
              </p>
              <ol>
                  <li>The electric vendors selected for data collection do NOT represent a sufficient
                      percentage of the total number of LIHEAP-assisted households that
                      use   {fuelType.description}   as their main heating fuel. (You are not
                      required to collect data from more than 5 electric utilities,
                      however, if your   {fuelType.description}   main heat households do not use
                      one of the five largest electric vendors you won&rsquo;t be
                      able to report data on them).</li>
                  <li>One or more of your electric vendors did not comply with the data request.</li>
                  <li>One or more of your electric vendors are providing electric billing data for some,
                      but not all, of the LIHEAP households they serve.</li>
                  <li>One or more of your electric vendors are only providing partial data (i.e. not a
                      full 12 consecutive months) for a sizeable portion of the households they serve.</li>
              </ol>
              <p>
                  Let's walk through each of these issues so that you can assess whether any of
                  them might be a problem for your data. Please answer each of the questions
                  below. Depending on your response, each question may ask you to outline
                  an action item to help you address the issue. <strong>If you don't know
                  the answer to a question, please indicate "Don't Know" and provide your
                  plans to acquire this information from IT department or programming
                  staff in the response box.</strong>
              </p>
              <ol>
                  <li>
                      How many LIHEAP-assisted households receive their baseload
                      electric service from one of the vendors from whom you
                      requested electric billing data?
                      <input id="hHServedByVendorsDataRequestedNum"
                          name="hHServedByVendorsDataRequestedNum"
                          value={fuelType.hHServedByVendorsDataRequestedNum} 
                          onChange={(changeEvent) => state.assessment2bFieldChangeHandler(changeEvent, fuelType)} 
                          className="form-control " />
                      {(fuelType.hHServedByVendorsDataRequestedStatus === Assessment2bHHServedByVendorsDataRequestedStatusEnum.EntryError)
                      &&
                          <span>This number cannot be less than the number of households for whom data was received.</span>
                      }
                      {(fuelType.hHServedByVendorsDataRequestedStatus === Assessment2bHHServedByVendorsDataRequestedStatusEnum.NotMeetTarget)
                      &&
                          <React.Fragment>
                              Based on your response it is clear that the vendors from whom you are
                              requesting data do not represent enough households to be representative of
                              the entire population of   {fuelType.description}   households in your state. You need
                              to request from more vendors or request from vendors that represent a
                              larger share of the population. Please indicate your plans for addressing
                              this issue in the response box below.
                              <textarea  name="hHServedByVendorsDataRequestedDesc"
                                id="hHServedByVendorsDataRequestedDesc" style={{width:"100%"}}
                                value={fuelType.hHServedByVendorsDataRequestedDesc}
                                onChange={(changeEvent) => state.assessment2bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                          </React.Fragment>
                      }
                      {(fuelType.hHServedByVendorsDataRequestedStatus === Assessment2bHHServedByVendorsDataRequestedStatusEnum.OverTargetNoIssues)
                      &&
                          <React.Fragment>
                              Vendor selection is not your sole problem. It must be something else. Move on to the next question.
                          </React.Fragment>
                      }
                      <br/><br/>
                  </li>
                  {(fuelType.hHServedByVendorsDataRequestedStatus === Assessment2bHHServedByVendorsDataRequestedStatusEnum.OverTargetNoIssues)
                      &&  
                      <li>
                      How many LIHEAP-assisted households are represented by the electric vendors that complied with your request?
                      <input id="hHServedByVendorsDataReceivedNum"
                          name="hHServedByVendorsDataReceivedNum"
                          value={fuelType.hHServedByVendorsDataReceivedNum} 
                          onChange={(changeEvent) => state.assessment2bFieldChangeHandler(changeEvent, fuelType)} 
                          className="form-control " />
                      {(fuelType.hHServedByVendorsDataReceivedStatus === Assessment2bHHServedByVendorsDataReceivedStatusEnum.EntryError)
                      &&
                          <span>This number cannot be less than the number of households for whom data was received.</span>
                      }
                      {(fuelType.hHServedByVendorsDataReceivedStatus === Assessment2bHHServedByVendorsDataReceivedStatusEnum.NotMeetTarget)
                      &&
                          <React.Fragment>
                              Based on your response it is clear that your issue is due to the fact that some
                              of your vendors are not complying with your data request. You need to either 1)
                              find a way to get more vendors to comply with their data request or 2) request
                              data from more vendors. Please indicate your plans for addressing this
                              issue in the response box below.                              
                              <textarea  name="hHServedByVendorsDataReceivedDesc"
                                id="hHServedByVendorsDataReceivedDesc" style={{width:"100%"}}
                                value={fuelType.hHServedByVendorsDataReceivedDesc}
                                onChange={(changeEvent) => state.assessment2bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                          </React.Fragment>
                      }
                      {(fuelType.hHServedByVendorsDataReceivedStatus === Assessment2bHHServedByVendorsDataReceivedStatusEnum.OverTargetNoIssues)
                      &&
                          <React.Fragment>
                              The number of vendors complying with your data request is not the sole problem.  It must be something else. Move on to the next question.
                          </React.Fragment>
                      }
                      <br/><br/>
                  </li>
                  }
                  {(fuelType.hHServedByVendorsDataReceivedStatus === Assessment2bHHServedByVendorsDataReceivedStatusEnum.OverTargetNoIssues)
                      &&
                      <li>
                      How many LIHEAP-assisted households have electric baseload billing data in your system, including households for whom you do not have a full 12 months of data? 
                      <input id="hHWithElectricDataNum"
                          name="hHWithElectricDataNum"
                          value={fuelType.hHWithElectricDataNum} 
                          onChange={(changeEvent) => state.assessment2bFieldChangeHandler(changeEvent, fuelType)} 
                          className="form-control " />
                      {(fuelType.hHWithElectricDataStatus === Assessment2bHHWithElectricDataStatusEnum.EntryError)
                      &&
                          <span>This number cannot be less than the number of households for whom data was received.</span>
                      }
                      {(fuelType.hHWithElectricDataStatus === Assessment2bHHWithElectricDataStatusEnum.NotMeetTarget)
                      &&
                          <React.Fragment>
                              Based on your response it is clear that your issue is that some
                              of your vendors are not supplying you with electric billing data for
                              all of the LIHEAP households they serve. You need to follow-up with
                              the vendors supplying data and work with them to ensure that they are
                              providing the data for as close to 100% of their LIHEAP-assisted
                              customers as possible, even if the vendor is not receiving a benefit
                              on behalf of the household. Please indicate your plans to address
                              this issue in the response box below. 
                              <textarea  name="hHWithElectricDataDesc"
                                id="hHWithElectricDataDesc" style={{width:"100%"}}
                                value={fuelType.hHWithElectricDataDesc}
                                onChange={(changeEvent) => state.assessment2bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                          </React.Fragment>
                      }
                      {(fuelType.hHWithElectricDataStatus === Assessment2bHHWithElectricDataStatusEnum.OverTargetNoIssues)
                      &&
                          <React.Fragment>
                              Vendors failing to provide any data for a substantial portion of their households is not the sole issue. Move on to the next question.
                          </React.Fragment>
                      }
                      <br/><br/>
                  </li>
                  }
                  {(fuelType.hHWithElectricDataStatus === Assessment2bHHWithElectricDataStatusEnum.OverTargetNoIssues)
                      &&
                      <li>
                      For how many households do you have a full 12 consecutive months of electric billing data? 
                      <input id="hH12MonthBillingDataNum"
                          name="hH12MonthBillingDataNum"
                          value={fuelType.hH12MonthBillingDataNum} 
                          onChange={(changeEvent) => state.assessment2bFieldChangeHandler(changeEvent, fuelType)} 
                          className="form-control " />
                      {(fuelType.hH12MonthBillingDataStatus === Assessment2bHH12MonthBillingDataNumStatusEnum.EntryError)
                      &&
                          <span>This number cannot be less than the number of households for whom data was received.</span>
                      }
                      {(fuelType.hH12MonthBillingDataStatus === Assessment2bHH12MonthBillingDataNumStatusEnum.NotMeetTarget)
                      &&
                          <React.Fragment>
                              Based on your response it is clear that your issue is  
                              that your vendors are not supplying enough records  
                              with a full 12 consecutive months of electric billing data.  
                              You  need to follow-up with the vendors supplying data and  
                              work with them to ensure that they are providing 12   
                              consecutive months of data for as many of their LIHEAP-assisted  
                              customers as possible, even if the vendor is not receiving  
                              a benefit on behalf of the household.
                          </React.Fragment>
                      }
                      {(fuelType.hH12MonthBillingDataStatus === Assessment2bHH12MonthBillingDataNumStatusEnum.OverTargetNoIssues)
                      &&
                          <React.Fragment>
                              Vendors providing only partial data for a substantial portion of their households is not the sole issue. Please move on to the next question.
                          </React.Fragment>
                      }
                      <br/><br/>
                  </li>
                  }
                  {((fuelType.hHServedByVendorsDataRequestedStatus === Assessment2bHHServedByVendorsDataRequestedStatusEnum.OverTargetNoIssues)
                      &&(fuelType.hHServedByVendorsDataReceivedStatus === Assessment2bHHServedByVendorsDataReceivedStatusEnum.OverTargetNoIssues)
                      &&(fuelType.hHWithElectricDataStatus === Assessment2bHHWithElectricDataStatusEnum.OverTargetNoIssues)
                      &&(fuelType.hH12MonthBillingDataStatus === Assessment2bHH12MonthBillingDataNumStatusEnum.OverTargetNoIssues))
                      &&<li>
                          It looks like your issue cannot be explained solely by any of the issues above. Therefore, it is likely to be a combination of things. Let’s take a look at the number of households “lost” at each step of the data collection process.
                          <ul>
                              <li>
                                  You missed out on the data for <strong>  {fuelType.hHServedByVendorsDataNotRequested} households </strong>  because they receive their electric service from vendors whom you did not select for data collection. 
                              </li>
                              <li>
                                  You Missed out on the data for <strong>  {fuelType.hHServedByVendorsDataNotReceived} households </strong>   because you requested data from the vendors that serve them, but those vendors did not comply with your request. 
                              </li>
                              <li>
                                  You missed out on the data for <strong>  {fuelType.hHServedByVendorsDataNotProvidingElectricData} households </strong>  because one or more of the electric vendors supplying you with data did not supply any data at all for a sizeable portion of the households they serve. 
                              </li>
                              <li>
                                  You missed out on the data for <strong>  {fuelType.hHServedByVendorsDataNotProviding12MonthsData } households </strong>  because one or more of the electric vendors supplying you with data supplied some, but not a full 12 consecutive months, of data for a significant percentage of the households they serve.  
                              </li>
                          </ul>
                          In light of this information. What do you plan to do to improve the percentage of households from whom you collected electric baseload data?
                          
                          <textarea  name="improvePercenthouseholdDataColDesc"
                                id="improvePercenthouseholdDataColDesc" style={{width:"100%"}}
                                value={fuelType.improvePercenthouseholdDataColDesc}
                                onChange={(changeEvent) => state.assessment2bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                          <br/><br/>
                      </li>
                  }               
              </ol>
          </React.Fragment>
        }
    </div>
);
export default Assessment2bQuestions;
